import { Component, Input, OnInit } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@Component({
  selector: 'app-custom-tag',
  templateUrl: './custom-tag.component.html',
  styleUrls: ['./custom-tag.component.scss'],
  standalone: true,
  imports: [TagModule, BrowserAnimationsModule]
})
export class CustomTagComponent implements OnInit {

  @Input() icon: string = "";
  @Input() label: string = "";
  @Input() visibleLabel: boolean = true;
  @Input() rounded: boolean = false;
  @Input() textLeft: boolean = false;
  @Input() severity: string = "primary";
  @Input() value: string = "";

  constructor() { }

  ngOnInit() {
  }

}
